import { CampaignsList } from '@/components/CampaignsList';

export function CampaignsWrapper() {
  return <CampaignsList />;
}
